var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAuthFailed(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.9 9.2C35.7 9.2 24.2 20.8 24.2 34.9V40.8H32.8V34.9C32.8 25.4 40.5 17.7 50 17.7C59.5 17.7 67.2 25.4 67.2 34.9V40.8H75.8V34.9C75.6 20.8 64 9.2 49.9 9.2Z",
    fill: "#CCE5FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.7 51.3V102.6C91.7 107.2 87.9 111 83.3 111H16.3C11.7 111 7.89999 107.2 7.89999 102.6V51.3C7.89999 46.7 11.7 42.9 16.3 42.9H83.3C88 42.9 91.7 46.7 91.7 51.3Z",
    fill: "#CCE5FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.6 40.8H66V30.8C66 21.9 58.8 14.6 49.8 14.6C40.8 14.6 33.6 21.8 33.6 30.8V40.8H23.1V30.8C23.1 16 35.1 4 49.9 4C64.7 4 76.6 16 76.6 30.7V40.8ZM68 38.8H74.6V30.8C74.6 17.1 63.5 6 49.9 6C36.3 6 25.1 17.1 25.1 30.7V38.7H31.7V30.7C31.7 20.7 39.8 12.5 49.9 12.5C60 12.5 68 20.7 68 30.7V38.8Z",
    fill: "#2171B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.4 40.7C86.9 40.7 89.8 43.5 89.8 47.1V90.2V98.5C89.8 102 87 104.9 83.4 104.9H16.4C12.9 104.9 10 102.1 10 98.5V47.1C10 43.6 12.8 40.7 16.4 40.7H83.4ZM83.4 38.7H16.4C11.8 38.7 8 42.5 8 47.1V98.4C8 103 11.8 106.8 16.4 106.8H83.4C88 106.8 91.8 103 91.8 98.4V90.1V47.1C91.7 42.5 88 38.7 83.4 38.7Z",
    fill: "#2171B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.3 82.8C50.9 82.8 51.3 83.2 51.3 83.8V88.8C51.3 89.4 50.9 89.8 50.3 89.8H49.4C48.8 89.8 48.4 89.4 48.4 88.8V83.8C48.4 83.2 48.8 82.8 49.4 82.8H50.3ZM50.3 80.8H49.4C47.7 80.8 46.4 82.1 46.4 83.8V88.8C46.4 90.5 47.7 91.8 49.4 91.8H50.3C52 91.8 53.3 90.5 53.3 88.8V83.8C53.3 82.2 52 80.8 50.3 80.8Z",
    fill: "#2171B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4 116C101.943 116 111.3 106.643 111.3 95.1C111.3 83.5572 101.943 74.2 90.4 74.2C78.8573 74.2 69.5 83.5572 69.5 95.1C69.5 106.643 78.8573 116 90.4 116Z",
    fill: "#F7E7E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4 76.3C100.8 76.3 109.3 84.8 109.3 95.2C109.3 105.6 100.8 114 90.4 114C80 114 71.5 105.5 71.5 95.1C71.5 84.7 80 76.3 90.4 76.3ZM90.4 74.3C78.9 74.3 69.5 83.6 69.5 95.2C69.5 106.8 78.8 116 90.4 116C102 116 111.3 106.7 111.3 95.1C111.3 83.5 101.9 74.3 90.4 74.3Z",
    fill: "#DE5656"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4 106.1C91.5598 106.1 92.5 105.16 92.5 104C92.5 102.84 91.5598 101.9 90.4 101.9C89.2402 101.9 88.3 102.84 88.3 104C88.3 105.16 89.2402 106.1 90.4 106.1Z",
    fill: "#DE5656"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4 84.2H90.3C89.5 84.2 88.8 84.9 88.8 85.7V97.3C88.8 98.1 89.5 98.8 90.3 98.8H90.4C91.2 98.8 91.9 98.1 91.9 97.3V85.7C91.9 84.9 91.3 84.2 90.4 84.2Z",
    fill: "#DE5656"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 103.3,
    height: 112,
    fill: "white",
    transform: "translate(8 4)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuthFailed);
export default __webpack_public_path__ + "static/media/auth-failed.6a7b36a2113149b1490a84b47efa3ca9.svg";
export { ForwardRef as ReactComponent };